<template>
  <!-- Rendered at the end of <body>, outside the semi-transparent header, so the
       page behind never shows through the popup. -->
  <Teleport to="body">
  <div class="phone-modal-overlay" @click.self="$emit('close')">
    <div class="phone-modal">
      <button class="close-btn" @click="$emit('close')">✕</button>
      <h2 class="modal-title">Give Us a Call!</h2>
      <p class="modal-subtitle">Choose your nearest location:</p>

      <div class="location-buttons">
        <a href="tel:269-262-5055" class="location-btn southwest">
          <span class="location-label">Southwest Michigan</span>
          <span class="location-number"><svg class="phone-icon" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false"><path fill="currentColor" d="M6.6 10.8a15.1 15.1 0 0 0 6.6 6.6l2.2-2.2a1 1 0 0 1 1-.25 11.4 11.4 0 0 0 3.6.57 1 1 0 0 1 1 1V20a1 1 0 0 1-1 1A17 17 0 0 1 3 4a1 1 0 0 1 1-1h3.5a1 1 0 0 1 1 1c0 1.25.2 2.45.57 3.57a1 1 0 0 1-.25 1z"/></svg>(269) 262-5055</span>
        </a>
        <a href="tel:989-858-3559" class="location-btn northern">
          <span class="location-label">Northern Michigan</span>
          <span class="location-number"><svg class="phone-icon" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false"><path fill="currentColor" d="M6.6 10.8a15.1 15.1 0 0 0 6.6 6.6l2.2-2.2a1 1 0 0 1 1-.25 11.4 11.4 0 0 0 3.6.57 1 1 0 0 1 1 1V20a1 1 0 0 1-1 1A17 17 0 0 1 3 4a1 1 0 0 1 1-1h3.5a1 1 0 0 1 1 1c0 1.25.2 2.45.57 3.57a1 1 0 0 1-.25 1z"/></svg>(989) 858-3559</span>
        </a>
      </div>
    </div>
  </div>
  </Teleport>
</template>

<script>
export default {
  name: 'PhoneModal',
  emits: ['close'],
}
</script>

<style scoped>
.phone-modal-overlay {
  /* Same font as the rest of the site (#app sets it; this popup lives outside #app) */
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.phone-modal {
  background: linear-gradient(135deg, #002655 0%, #1a3a5c 60%, #4a7ba7 100%);
  border-radius: 16px;
  padding: 40px 32px 32px;
  width: 90%;
  max-width: 420px;
  position: relative;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.5);
  text-align: center;
}

.close-btn {
  position: absolute;
  top: 12px;
  right: 16px;
  background: none;
  border: none;
  color: rgba(255,255,255,0.7);
  font-size: 1.4rem;
  cursor: pointer;
  transition: color 0.2s;
}
.close-btn:hover {
  color: #f1c40f;
}

.modal-title {
  color: #fff;
  font-size: 1.6rem;
  font-weight: 700;
  margin: 0 0 8px;
}

.modal-subtitle {
  color: rgba(255,255,255,0.75);
  font-size: 1rem;
  margin: 0 0 28px;
}

.location-buttons {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.location-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 18px 24px;
  border-radius: 12px;
  text-decoration: none;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.location-btn:hover {
  transform: translateY(-3px);
}

.southwest,
.northern {
  border: 2px solid rgba(255, 255, 255, 0.35);
  border-radius: 10px;
  background: linear-gradient(135deg, #8d0808 0%, #bf1414 55%, #e04a2d 100%);
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.34), 0 0 0 1px rgba(255, 255, 255, 0.08) inset;
}
.southwest:hover,
.northern:hover {
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.32), 0 0 0 1px rgba(255, 255, 255, 0.1) inset;
  filter: brightness(1.05);
}
.location-btn:focus-visible {
  outline: 3px solid #f1c40f;
  outline-offset: 2px;
}
.location-number {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.location-label {
  color: rgba(255,255,255,0.85);
  font-size: 0.85rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-bottom: 4px;
}

.location-number {
  color: #fff;
  font-size: 1.5rem;
  font-weight: 700;
  letter-spacing: 1px;
}
</style>
